import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useT } from "../../shared/i18n";
import { BarcodeIcon } from "../../shared/components/icons";
import { CheckIcon } from "../../shared/components/icons";
import { DeadlineViewControls } from "../../shared/components/Deadlines";
import { useDemoMode } from "../demo/useDemoMode";

/** Title, scan-to-add entry point, deadline switch and bulk-mode toggle for the
 *  items list. Sort and property filters live in the shared filter table. */
export function ItemListToolbar({
  bulkMode,
  onToggleBulk,
  onScan,
  deadlineView,
  onDeadlineViewChange,
  overdue,
  soon,
}: {
  bulkMode: boolean;
  onToggleBulk: () => void;
  onScan: () => void;
  deadlineView: boolean;
  onDeadlineViewChange: (enabled: boolean) => void;
  overdue: number;
  soon: number;
}) {
  const t = useT();
  const readOnly = useDemoMode();
  return (
    <Stack direction="row" alignItems="center" spacing={1} sx={{ p: 1, flexWrap: "wrap", gap: 1 }}>
      <Typography variant="h6" sx={{ flexGrow: 1 }}>
        {t("itemsList")}
      </Typography>
      <DeadlineViewControls
        overdue={overdue}
        soon={soon}
        checked={deadlineView}
        onChange={onDeadlineViewChange}
      />
      {!readOnly && (
        <>
          <Button
            variant="contained"
            startIcon={<BarcodeIcon />}
            onClick={onScan}
            size="small"
          >
            {t("scanToAddTitle")}
          </Button>
          <Button
            variant={bulkMode ? "contained" : "outlined"}
            onClick={onToggleBulk}
            startIcon={<CheckIcon />}
            size="small"
          >
            {bulkMode ? t("cancelSelection") : t("bulkEdit")}
          </Button>
        </>
      )}
    </Stack>
  );
}